import React, { memo } from "react";

import LessonPlanCustom from "./LessonPlanCustom";

const LessonPlanCustomContainer = () => {
    return <LessonPlanCustom />;
};

export default memo(LessonPlanCustomContainer);
